import { useEffect } from "react";

export default function NoPage() {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = "https://app.zeqa.net/";
    }, 5000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <section className="_404-stack">
      <div className="_404-container zeqa-container">
        <div className="_404-div">
          <div className="_404-tile-div">
            <h1
              style={{ marginTop: 0, marginLeft: 10, marginRight: 10 }}
              className="_404-heading"
            >
              404 Error
            </h1>
            <div className="_404-text loading-animation">Redirecting In </div>
          </div>
        </div>
      </div>
    </section>
  );
}
